export default "__VITE_ASSET__e74ded13__"